import React, { useEffect, useState } from 'react';
import { useCart } from '../../context/CartContext';
import api from '../../services/api';

const TopBar = () => {
  const { cartItems } = useCart();
  const [threshold, setThreshold] = useState(3500);
  const [progress, setProgress] = useState(0);
  const [remaining, setRemaining] = useState(threshold);

  useEffect(() => {
    const fetchThreshold = async () => {
      try {
        const res = await api.get('/settings/announcement');
        if (res.freeShippingThreshold) {
          setThreshold(res.freeShippingThreshold);
        }
      } catch (err) {
        console.error('Failed to fetch threshold');
      }
    };
    fetchThreshold();
  }, []);

  useEffect(() => {
    const subtotal = cartItems?.reduce((acc, item) => acc + item.price * item.quantity, 0) || 0;
    const remainingAmount = Math.max(0, threshold - subtotal);
    const progressPercentage = Math.min(100, (subtotal / threshold) * 100);

    setRemaining(remainingAmount);
    setProgress(progressPercentage);
  }, [cartItems, threshold]);

  return (
    <div 
      className="pt-5 pb-[25px] px-5 text-center my-2.5 rounded"
      style={{ backgroundColor: 'var(--secondary-color)' }}
    >
      <span className="text-white text-sm">
        You're only <span className="text-yellow-300 font-semibold">Rs {remaining.toLocaleString()}</span> away from free shipping!
      </span>

      <div className="bg-gray-300 h-2 w-3/5 mx-auto mt-2 rounded-full overflow-hidden">
        <div
          className="bg-black h-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default TopBar;